import apiProvider from './utilities/provider'

const url = 'custom-assessments'

const apiCustomAssessment = {}

apiCustomAssessment.getCandidateAssessment = (apiKey) =>
  apiProvider.getAll(`${url}/candidate/${apiKey}`)

apiCustomAssessment.startAssessment = (apiKey) =>
  apiProvider.post(`${url}/candidate/${apiKey}/start`, {})

apiCustomAssessment.submitAssessment = (apiKey, data) =>
  apiProvider.post(`${url}/candidate/${apiKey}/submit`, data)

export default apiCustomAssessment
